import type { SxProps, Theme } from '@mui/material';

/**
 * Caps block width to the visible viewport when a parent resolves `100%` wider than the screen
 * (e.g. scrollbar gutter, sidebar inset + nested `100%`).
 */
export const viewportSafeWidthSx: SxProps<Theme> = {
    width: '100%',
    minWidth: 0,
    maxWidth: 'min(100%, 100dvw)',
    boxSizing: 'border-box',
};

export const viewportSafeColumnSx: SxProps<Theme> = {
    ...viewportSafeWidthSx,
    overflowX: 'hidden',
};
